var React = require('react');

function GetStartedIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M20 8a1 1 0 0 0-1 1v11a1 1 0 1 0 2 0V9a1 1 0 0 0-1-1zM9 21c0-4.664 2.903-8.65 7-10.25v2.185a9 9 0 1 0 8 0V10.75c4.097 1.6 7 5.586 7 10.25 0 6.075-4.925 11-11 11S9 27.075 9 21z","fill":"#fff"}));
}

GetStartedIcon.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = GetStartedIcon;

GetStartedIcon.default = GetStartedIcon;
